export namespace LivePreviewConsts {
  export const defaultPreviewSize = 225;
  export const fullSize = '100%';
}
